import { Box, Text, TextInput } from "@mantine/core";
import { IconPlus, IconSearch, IconX } from "@tabler/icons-react";
import IconMessageDotsCircle from "icons/common/message-dots-circle.svg";
import { FC } from "react";
import { useTranslation } from "react-i18next";

interface ChatRoomsHeaderProps {
  search: string;
  onSearchChange: (value: string) => void;
  isDesktop?: boolean;
  onNewDiscussion: () => void;
  onClose?: () => void;
}

export const ChatRoomsHeader: FC<ChatRoomsHeaderProps> = ({
  search,
  onSearchChange,
  isDesktop,
  onNewDiscussion,
  onClose,
}) => {
  const { t } = useTranslation("discussions");

  return (
    <Box className="w-full bg-white px-4 pt-3 pb-2.5 flex flex-col gap-2 sticky top-0 z-10 shadow-sm">
      <Box className="flex items-center justify-between gap-3">
        <Box className="flex items-center gap-3">
          <IconMessageDotsCircle
            width={26}
            height={26}
            color="var(--color-blue)"
          />
          <Text fz={20} fw={700} c="var(--color-gray-dark)">
            {t("title").toUpperCase()}
          </Text>
          {isDesktop && (
            <button
              onClick={onNewDiscussion}
              className="w-[23px] h-[23px] rounded-full bg-green flex items-center justify-center text-white shrink-0 cursor-pointer"
              aria-label="New discussion"
              type="button"
            >
              <IconPlus size={14} strokeWidth={3} />
            </button>
          )}
        </Box>
        {onClose && (
          <button
            aria-label="Close chat"
            type="button"
            onClick={onClose}
            className="p-0 flex items-center text-gray-dark hover:text-black cursor-pointer"
          >
            <IconX size={32} />
          </button>
        )}
      </Box>
      <TextInput
        placeholder={t("searchPlaceholder")}
        value={search}
        onChange={e => onSearchChange(e.currentTarget.value)}
        rightSection={<IconSearch size={16} />}
      />
    </Box>
  );
};
